/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StatementDisplayStatus } from './StatementDisplayStatus';
import {
    StatementDisplayStatusFromJSON,
    StatementDisplayStatusFromJSONTyped,
    StatementDisplayStatusToJSON,
    StatementDisplayStatusToJSONTyped,
} from './StatementDisplayStatus';
import type { BalanceUnitStatementEntryDebit } from './BalanceUnitStatementEntryDebit';
import {
    BalanceUnitStatementEntryDebitFromJSON,
    BalanceUnitStatementEntryDebitFromJSONTyped,
    BalanceUnitStatementEntryDebitToJSON,
    BalanceUnitStatementEntryDebitToJSONTyped,
} from './BalanceUnitStatementEntryDebit';
import type { IdNameResultOfint } from './IdNameResultOfint';
import {
    IdNameResultOfintFromJSON,
    IdNameResultOfintFromJSONTyped,
    IdNameResultOfintToJSON,
    IdNameResultOfintToJSONTyped,
} from './IdNameResultOfint';
import type { StatementTuitionBreakdown } from './StatementTuitionBreakdown';
import {
    StatementTuitionBreakdownFromJSON,
    StatementTuitionBreakdownFromJSONTyped,
    StatementTuitionBreakdownToJSON,
    StatementTuitionBreakdownToJSONTyped,
} from './StatementTuitionBreakdown';

/**
 * 
 * @export
 * @interface BalanceUnitStatementEntry
 */
export interface BalanceUnitStatementEntry {
    /**
     * 
     * @type {Date}
     * @memberof BalanceUnitStatementEntry
     */
    createdAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof BalanceUnitStatementEntry
     */
    identifier?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof BalanceUnitStatementEntry
     */
    date?: Date;
    /**
     * 
     * @type {string}
     * @memberof BalanceUnitStatementEntry
     */
    entryType?: string;
    /**
     * 
     * @type {string}
     * @memberof BalanceUnitStatementEntry
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BalanceUnitStatementEntry
     */
    note?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BalanceUnitStatementEntry
     */
    transactionCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BalanceUnitStatementEntry
     */
    transactionCodeName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BalanceUnitStatementEntry
     */
    invoiceNo?: string | null;
    /**
     * 
     * @type {BalanceUnitStatementEntryDebit}
     * @memberof BalanceUnitStatementEntry
     */
    debit?: BalanceUnitStatementEntryDebit | null;
    /**
     * 
     * @type {BalanceUnitStatementEntryDebit}
     * @memberof BalanceUnitStatementEntry
     */
    credit?: BalanceUnitStatementEntryDebit | null;
    /**
     * 
     * @type {BalanceUnitStatementEntryDebit}
     * @memberof BalanceUnitStatementEntry
     */
    taxAmount?: BalanceUnitStatementEntryDebit | null;
    /**
     * 
     * @type {BalanceUnitStatementEntryDebit}
     * @memberof BalanceUnitStatementEntry
     */
    surchargeAmount?: BalanceUnitStatementEntryDebit | null;
    /**
     * 
     * @type {string}
     * @memberof BalanceUnitStatementEntry
     */
    currency?: string | null;
    /**
     * 
     * @type {StatementDisplayStatus}
     * @memberof BalanceUnitStatementEntry
     */
    status?: StatementDisplayStatus;
    /**
     * 
     * @type {string}
     * @memberof BalanceUnitStatementEntry
     */
    failureReason?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BalanceUnitStatementEntry
     */
    externalStatus?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof BalanceUnitStatementEntry
     */
    isPending?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BalanceUnitStatementEntry
     */
    paymentTransactionId?: string | null;
    /**
     * 
     * @type {IdNameResultOfint}
     * @memberof BalanceUnitStatementEntry
     */
    student?: IdNameResultOfint | null;
    /**
     * 
     * @type {IdNameResultOfint}
     * @memberof BalanceUnitStatementEntry
     */
    _class?: IdNameResultOfint | null;
    /**
     * 
     * @type {IdNameResultOfint}
     * @memberof BalanceUnitStatementEntry
     */
    season?: IdNameResultOfint | null;
    /**
     * 
     * @type {IdNameResultOfint}
     * @memberof BalanceUnitStatementEntry
     */
    location?: IdNameResultOfint | null;
    /**
     * 
     * @type {StatementTuitionBreakdown}
     * @memberof BalanceUnitStatementEntry
     */
    tuitionBreakdown?: StatementTuitionBreakdown | null;
}



/**
 * Check if a given object implements the BalanceUnitStatementEntry interface.
 */
export function instanceOfBalanceUnitStatementEntry(value: object): value is BalanceUnitStatementEntry {
    return true;
}

export function BalanceUnitStatementEntryFromJSON(json: any): BalanceUnitStatementEntry {
    return BalanceUnitStatementEntryFromJSONTyped(json, false);
}

export function BalanceUnitStatementEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): BalanceUnitStatementEntry {
    if (json == null) {
        return json;
    }
    return {
        
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'identifier': json['identifier'] == null ? undefined : json['identifier'],
        'date': json['date'] == null ? undefined : (new Date(json['date'])),
        'entryType': json['entryType'] == null ? undefined : json['entryType'],
        'description': json['description'] == null ? undefined : json['description'],
        'note': json['note'] == null ? undefined : json['note'],
        'transactionCode': json['transactionCode'] == null ? undefined : json['transactionCode'],
        'transactionCodeName': json['transactionCodeName'] == null ? undefined : json['transactionCodeName'],
        'invoiceNo': json['invoiceNo'] == null ? undefined : json['invoiceNo'],
        'debit': json['debit'] == null ? undefined : BalanceUnitStatementEntryDebitFromJSON(json['debit']),
        'credit': json['credit'] == null ? undefined : BalanceUnitStatementEntryDebitFromJSON(json['credit']),
        'taxAmount': json['taxAmount'] == null ? undefined : BalanceUnitStatementEntryDebitFromJSON(json['taxAmount']),
        'surchargeAmount': json['surchargeAmount'] == null ? undefined : BalanceUnitStatementEntryDebitFromJSON(json['surchargeAmount']),
        'currency': json['currency'] == null ? undefined : json['currency'],
        'status': json['status'] == null ? undefined : StatementDisplayStatusFromJSON(json['status']),
        'failureReason': json['failureReason'] == null ? undefined : json['failureReason'],
        'externalStatus': json['externalStatus'] == null ? undefined : json['externalStatus'],
        'isPending': json['isPending'] == null ? undefined : json['isPending'],
        'paymentTransactionId': json['paymentTransactionId'] == null ? undefined : json['paymentTransactionId'],
        'student': json['student'] == null ? undefined : IdNameResultOfintFromJSON(json['student']),
        '_class': json['class'] == null ? undefined : IdNameResultOfintFromJSON(json['class']),
        'season': json['season'] == null ? undefined : IdNameResultOfintFromJSON(json['season']),
        'location': json['location'] == null ? undefined : IdNameResultOfintFromJSON(json['location']),
        'tuitionBreakdown': json['tuitionBreakdown'] == null ? undefined : StatementTuitionBreakdownFromJSON(json['tuitionBreakdown']),
    };
}

export function BalanceUnitStatementEntryToJSON(json: any): BalanceUnitStatementEntry {
    return BalanceUnitStatementEntryToJSONTyped(json, false);
}

export function BalanceUnitStatementEntryToJSONTyped(value?: BalanceUnitStatementEntry | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'createdAt': value['createdAt'] == null ? value['createdAt'] : value['createdAt'].toISOString(),
        'identifier': value['identifier'],
        'date': value['date'] == null ? value['date'] : value['date'].toISOString().substring(0,10),
        'entryType': value['entryType'],
        'description': value['description'],
        'note': value['note'],
        'transactionCode': value['transactionCode'],
        'transactionCodeName': value['transactionCodeName'],
        'invoiceNo': value['invoiceNo'],
        'debit': BalanceUnitStatementEntryDebitToJSON(value['debit']),
        'credit': BalanceUnitStatementEntryDebitToJSON(value['credit']),
        'taxAmount': BalanceUnitStatementEntryDebitToJSON(value['taxAmount']),
        'surchargeAmount': BalanceUnitStatementEntryDebitToJSON(value['surchargeAmount']),
        'currency': value['currency'],
        'status': StatementDisplayStatusToJSON(value['status']),
        'failureReason': value['failureReason'],
        'externalStatus': value['externalStatus'],
        'isPending': value['isPending'],
        'paymentTransactionId': value['paymentTransactionId'],
        'student': IdNameResultOfintToJSON(value['student']),
        'class': IdNameResultOfintToJSON(value['_class']),
        'season': IdNameResultOfintToJSON(value['season']),
        'location': IdNameResultOfintToJSON(value['location']),
        'tuitionBreakdown': StatementTuitionBreakdownToJSON(value['tuitionBreakdown']),
    };
}

